<template>
  <section class="w-100 fill-height" style="background-color: #fafafa">
    <DataTable 
      :opt="optDataTable"
      title="Grupos"
      collection="agentGroups"
      register="groups"
      orderBy="name"
      :details=details
    />
  </section>
</template>

<script>
import DataTable from "@/components/Registers/DataTable"
import { createNamespacedHelpers } from 'vuex'
const { mapGetters:registersGetters, mapActions:registersActions } = createNamespacedHelpers('registers')

export default {
  name: "MonitoredGroups",
  components: { DataTable },
  data() {
    return {
      details:[
        {
          collection: 'users',
          register: 'agents',
          filters: [
            { key: this.$db.FieldPath.documentId(), operator: 'in', value: 'res.agents' }
          ],
        },
        {
          collection: 'channels',
          register: 'channels',
          filters: [
            { key: this.$db.FieldPath.documentId(), operator: 'in', value: 'res.channels' }
          ],
        },
      ]
    }
  },
  computed: {
    ...registersGetters(['registers']),
    agentGroups() {
      return this.registers.agentGroups || []
    },
    optDataTable() {
      return {
        headers: this.headers,
        items: this.agentGroups,
        sortBy: "name",
        form: {
          newLabel: `Novo Grupo`,
          title: 'Grupo',
          maxWidth: '600px',
          inputs: this.inputs
        }
      }
    },
    headers() {
      return [
        { text: 'ID', value: 'id', copy: true, hideText: true },
        { text: 'Nome', value: 'name' },
        { text: 'Descrição', value: 'description'},
        { text: 'Supervisores', value: 'agents', detail: 'agents.displayName', chips: true},
        { text: 'Canais', value: 'channels', detail: 'channels.displayName', chips: true},
        { text: 'Última Atualização', value: 'lifeControl.modifiedAt', dateHour: true },
        { 
          text: 'Ações', 
          value: 'data-table-actions',
          removeClients: true
        }
      ]
    },
    inputs() {
      return [
        { type: 'text-field', label: 'Nome do Grupo', value: 'name', rules: [v => !!v || 'Nome é obrigatório'] },
        { type: 'textarea', label: 'Descrição', value: 'description' },
        { 
          type: 'autocomplete', 
          label: 'Supervisores', 
          value: 'agents', 
          items: 'agents', 
          itemText: 'displayName', 
          itemValue: 'id',
          multiple: true, 
          chips: true, 
          smallChips: true, 
          deletableChips: true, 
          returnObject: true,
        },
        { 
          type: 'autocomplete', 
          label: 'Canais', 
          value: 'channels', 
          items: 'channels', 
          itemText: 'displayName', 
          itemValue: 'id',
          multiple: true, 
          chips: true, 
          smallChips: true, 
          deletableChips: true, 
          returnObject: true,
          search: {
            collection: 'channels', 
            register: 'channels', 
            orderBy: 'displayName', 
            filters: [{ key: 'monitored', operator: '==', value: true }]
          },
        }
      ]
    }
  },
  methods: {
    ...registersActions(['observer']),
    
    initRegister() {
      this.observer({
        collection: 'agentGroups',
        register: 'agentGroups',
        details: this.details
      })
    }
  },
  created() {
    this.initRegister()
  }
}
</script>

<style scoped>
</style>
